export const TOSS_ODD_VALUE = 100;
export const EXCH_COMPETITIONS_MENU = 'ExchCompetitionsMenu';
export const WL_PREFIX_LIST = ['wl1', 'wl2', 'casino', 'pay', 'krishna'];
export const SUBDOMAIN_LIST = ['dev', 'stage', 'v2'];
export const EXCEPTION_SUBDOMAIN_LIST = ['wl1', 'wl2'];
export const BET_TIMEOUT = 20000;
